<template>
  <div class="dialog-wrap">
    <el-dialog title="订单详情"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="handleClose"
               :width="dialogWidth">
      <div class="order-wrap">
        <div class="card-wrap">
          <div class="inner">
            <div class="title">基础信息</div>
            <div class="info-wrap">
              <div class="info-row">
                <div class="label">订单状态：</div>
                <!--  <div class="value">{{ statusRender() }}</div> -->
                <div class="value">
                  <el-select v-model="content.status"
                             placeholder="请选择"
                             @change="changeStatus">
                    <el-option label="待支付"
                               :value="0"> </el-option>
                    <el-option label="已支付"
                               :value="1"> </el-option>
                    <el-option label="待发货"
                               :value="2"> </el-option>
                    <el-option label="待收货"
                               :value="3"> </el-option>
                    <el-option label="已完成"
                               :value="4"> </el-option>
                    <el-option label="已取消"
                               :value="5"> </el-option>
                  </el-select>
                </div>
              </div>
              <div class="info-row">
                <div class="label">创建时间：</div>
                <div class="value">
                  {{
                    $moment(content.create_time).format(
                      "YYYY.MM.DD HH:mm:ss"
                    ) || "--"
                  }}
                </div>
              </div>
              <div class="info-row">
                <div class="label">系统订单号：</div>
                <div class="value">{{ content.order_no || "--" }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-wrap"
             v-if="activityInfo">
          <div class="inner"
               v-if="activityInfo.activity_group">
            <div class="title">拼团信息</div>
            <div class="info-wrap">
              <div class="info-row">
                <div class="label">拼团ID：</div>
                <div class="value"
                     v-if="activityInfo.activity_group">
                  {{ activityInfo.activity_group.id }}
                </div>
                <div v-else> -</div>
              </div>
              <div class="info-row">
                <div class="label">拼团状态：</div>
                <div class="value"
                     v-if="activityInfo.activity_group">
                  {{
                    formateActivityStatus(activityInfo.activity_group.status)
                  }}
                </div>
              </div>
              <div class="info-row">
                <div class="label">拼团人数：</div>
                <div class="value"
                     v-if="activityInfo.activity_group">
                  {{ activityInfo.activity_group.user_count }}人团
                </div>
              </div>
              <div class="info-row">
                <div class="label">已拼人数：</div>
                <div class="value"
                     v-if="activityInfo.activity_group">
                  {{ activityInfo.activity_group.done_user_count }}人
                </div>
              </div>
              <div class="info-row">
                <div class="label">发起时间：</div>
                <div class="value"
                     v-if="activityInfo.activity_group">
                  {{
                    $moment(activityInfo.activity_group.create_time).format(
                      "YYYY.MM.DD HH:mm:ss"
                    )
                  }}
                </div>
              </div>
              <div class="info-row">
                <div class="label">更新时间：</div>
                <div class="value"
                     v-if="activityInfo.activity_group">
                  {{
                    $moment(activityInfo.activity_group.update_time).format(
                      "YYYY.MM.DD HH:mm:ss"
                    )
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-wrap">
          <div class="inner">
            <div class="title">商品信息</div>
            <div class="info-wrap">
              <div class="info-row">
                <div class="label">商品封面：</div>
                <div class="value">
                  <div v-if="content.ref_type == 7">
                    <img v-for="(item, index) in content.multi_ref_list"
                         :key="index"
                         :src="item.goods_img"
                         alt=""
                         style="margin: 0px 6px" />
                  </div>
                  <img :src="content.goods_img"
                       alt="" />
                </div>
              </div>
              <div class="info-row">
                <div class="label">商品类型：</div>
                <div class="value">
                  {{
                    {
                      "0": "无",
                      "1": "课程",
                      "2": "题库",
                      "3": "专栏",
                      "4": "资料",
                      "5": "文章",
                      "6": "学长",
                      "7": "联报",
                    }[content.ref_type] || "--"
                  }}
                </div>
              </div>
              <div class="info-row"
                   style="align-items: start">
                <div class="label">商品名称：</div>
                <div class="goods-name-value"
                     v-if="content.ref_type == 7">
                  <span class="goods-name-span"
                        v-for="(item, index) in content.multi_ref_list"
                        :key="index">{{ item.goods_name }}</span>
                </div>
                <span v-else>{{ content.goods_name }}</span>
              </div>
              <div class="info-row"
                   v-if="properties.length > 0">
                <div class="label">商品规格：</div>
                <div v-for="(item,i) in properties"
                     :key="i">
                  <span class="properties-style"> {{item.key}}：{{item.val}}
                    <template v-if="i < properties.length - 1">,</template>
                    <template v-else>;</template>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-wrap">
          <div class="inner">
            <div class="title">支付信息</div>
            <div class="info-wrap">
              <!--  联报，多个商品原价  start-->
              <div class="info-row"
                   v-if="content.ref_type == 7">
                <div class="label">商品价格：</div>
                <div class="value">{{ formateMulti_ref_listPrice() }}</div>
              </div>
              <!--  联报，多个商品原价  end-->

              <!--  联报，多个商品联报价  start-->
              <div class="info-row"
                   v-if="content.ref_type == 7">
                <div class="label">联报优惠：</div>
                <div class="value">{{ formateMulti_ref_listJointPrice() }}</div>
              </div>
              <!--  联报，多个商品联报价   end-->

              <div class="info-row"
                   v-else>
                <div class="label">商品价格：</div>
                <div class="value">{{ content.price || "0" }}元</div>
              </div>
              <div class="info-row"
                   v-if="content.earnest_order_id && content.earnest_order_amount">
                <div class="label">定金抵扣：</div>
                <div class="value">{{ content.earnest_order_amount }}元</div>
              </div>
              <div class="info-row">
                <div class="label">优惠券金额：</div>
                <div class="value">
                  {{ content.user_coupon_amount || "0" }}元
                </div>
              </div>
              <div class="info-row">
                <div class="label">订单总金额：</div>
                <div class="value">{{ content.total_amount || "0" }}元</div>
              </div>
              <div class="info-row">
                <div class="label">支付金额：</div>
                <div class="value">{{ content.pay_amount || "0" }}元</div>
              </div>

              <div class="info-row">
                <div class="label">支付方式：</div>
                <div class="value">
                  {{
                    {
                      "0": "--",
                      "1": "支付宝",
                      "2": "微信",
                      "3": "系统",
                      "4": "花呗分期",
                      "5": "研币",
                    }[content.pay_type] || "--"
                  }}
                </div>
              </div>
              <div class="info-row">
                <div class="label">支付状态：</div>
                <div class="value">
                  {{
                    { "0": "未支付", "1": "已支付", "2": "已取消" }[
                      content.pay_status
                    ] || "--"
                  }}
                </div>
              </div>
              <div class="info-row">
                <div class="label">支付时间：</div>
                <div class="value">
                  {{
                    content.pay_time
                      ? $moment(content.pay_time).format("YYYY.MM.DD HH:mm:ss")
                      : "--"
                  }}
                </div>
              </div>
              <div class="info-row">
                <div class="label">商户交易号：</div>
                <div class="value">{{ content.out_trade_no || "--" }}</div>
              </div>
              <div class="info-row">
                <div class="label">支付订单号：</div>
                <div class="value">{{ content.pay_trade_no || "--" }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-wrap"
             v-if="isRefund">
          <div class="inner"
               style="min-height: 0px">
            <div class="title">退款</div>
            <el-form ref="form"
                     label-width="85px"
                     style="margin-top: 16px"
                     :inline="true">
              <el-form-item label="退款金额">
                <el-input v-model="content.refund_amount"
                          style="width: 150px"></el-input>
                元
              </el-form-item>
              <el-form-item style="float: right">
                <el-button type="primary"
                           @click="profitSharing"
                           :disabled="unsplit_amount == 0">分账完结</el-button>
                <el-button type="primary"
                           @click="refund">退款</el-button>
              </el-form-item>
            </el-form>
            <div class="info-row"
                 style="margin-left: 16px">
              <div class="label">发起申请退款金额：</div>
              <div class="value">{{ content.apply_refund_fee || "0" }}元</div>
            </div>
            <div class="info-row"
                 style="margin-top: 16px; margin-left: 16px">
              <div class="label">成功退款到账金额：</div>
              <div class="value">{{ content.refund_fee || "0" }}元</div>
            </div>
          </div>
        </div>
        <div class="card-wrap">
          <div class="inner">
            <div class="title">用户信息</div>
            <div class="info-wrap">
              <div class="info-row">
                <div class="label">ID：</div>
                <div class="value">{{ user.id || "--" }}</div>
              </div>
              <div class="info-row">
                <div class="label">姓名：</div>
                <div class="value">{{ user.realname || "--" }}</div>
              </div>
              <div class="info-row">
                <div class="label">昵称：</div>
                <div class="value">{{ user.nickname || "--" }}</div>
              </div>
              <div class="info-row">
                <div class="label">手机号：</div>
                <div class="value">{{ user.mobile || "--" }}</div>
              </div>
              <div class="info-row">
                <div class="label">邮箱：</div>
                <div class="value">{{ user.email || "--" }}</div>
              </div>
              <div class="info-row">
                <div class="label">性别：</div>
                <div class="value">
                  {{ user.gender ? (user.gender == 1 ? "男" : "女") : "--" }}
                </div>
              </div>
              <div class="info-row">
                <div class="label">角色：</div>
                <div class="value">
                  {{ user.role ? (user.role == 1 ? "学生" : "学长") : "--" }}
                </div>
              </div>
              <div class="info-row">
                <div class="label">当前所在地：</div>
                <div class="value">
                  {{ user.location ? user.location.area || "--" : "--" }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-wrap">
          <div class="inner">
            <div class="title">收件信息</div>
            <div class="info-wrap">
              <div class="info-row">
                <div class="label">收件人姓名：</div>
                <div class="value">{{ content.receiver_name || "--" }}</div>
              </div>
              <div class="info-row">
                <div class="label">收件人手机号：</div>
                <div class="value">{{ content.receiver_mobile || "--" }}</div>
              </div>
              <div class="info-row">
                <div class="label">收件人邮箱：</div>
                <div class="value">{{ content.receiver_email || "--" }}</div>
              </div>
              <div class="info-row">
                <div class="label">收件人地址：</div>
                <div class="value">{{ content.receiver_address || "--" }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-wrap">
          <div class="inner">
            <div class="title">其他信息</div>
            <div class="info-wrap">
              <div class="info-row">
                <!-- onblur  -->
                <div class="label">买家备注：</div>
                <div class="value">
                  <el-input @input="Update('buyer_remark')"
                            type="textarea"
                            :rows="2"
                            placeholder="请输入买家备注"
                            v-model="content.buyer_remark">
                  </el-input>
                  <!-- {{ content.buyer_remark || "--" }} -->
                </div>
              </div>
              <div class="info-row">
                <div class="label">卖家备注：</div>
                <div class="value">

                  <el-input @input="Update('seller_remark')"
                            type="textarea"
                            :rows="2"
                            placeholder="请输入卖家备注"
                            v-model="content.seller_remark">
                  </el-input>
                  <!-- {{ content.seller_remark || "--" }} -->
                </div>
              </div>
              <div class="info-row">
                <div class="label">系统备注：</div>
                <div class="value">
                  <el-input @input="Update('system_remark')"
                            type="textarea"
                            :rows="2"
                            placeholder="请输入系统备注"
                            v-model="content.system_remark">
                  </el-input>
                  <!-- {{ content.system_remark || "--" }} -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>


<script>
import {
  orderrefund,
  memberOrderUpdate,
  memberOrderOne,
  profitSharingFinish,
  profitSharingAmountQuery,
} from '@/api/member.js'
import { computePermission } from '@/utils/helper.js'
import { memberActivityOrderOne } from '@/api/operation.js'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    id: {
      type: Number,
      default: null,
    },
    userContent: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      // 商品规格
      properties: [],
      dialogVisible: this.visible,
      user: this.userContent || {},
      isRefund: false,
      activityInfo: null,
      dialogWidth: document.body.clientWidth < 820 ? '400px' : '680px',
      content: {},
      unsplit_amount: 0,
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
      if (val) {
        this.fetchOrderdetail()
        /*     if (this.content.activity_id) {
              this.fetActivityInfo()
            } */
      }
    },
    userContent(val) {
      this.user = val
    },
  },
  created() {
    this.isRefund = computePermission('refund:order')
  },
  methods: {
    fetchOrderdetail() {
      const query = {
        id: this.id,
      }
      memberOrderOne(query).then((res) => {
        if (res) {
          this.content = res
          if (res.sku) {
            this.properties = res.sku.properties
            console.log('this.properties', this.properties)
          }

          if (res.activity_id) {
            this.fetActivityInfo()
          }
          if (res.pay_type == 2) {
            this.queryWechatProfitSharing()
          }
        }
      })
    },
    fetActivityInfo() {
      const query = {
        id: this.content.id,
        uid: this.content.uid,
      }
      memberActivityOrderOne(query).then((res) => {
        if (res) {
          this.activityInfo = res
        }
      })
    },
    queryWechatProfitSharing() {
      const query = {
        transaction_id: this.content.pay_trade_no,
      }
      profitSharingAmountQuery(query).then((res) => {
        if (res) {
          this.unsplit_amount = parseInt(res.data.unsplit_amount)
        }
      })
    },
    handleClose() {
      this.properties = []
      this.activityInfo = null
      this.$emit('close')
    },
    // 订单状态渲染
    statusRender() {
      const pay_status = {
        0: '未支付',
        1: '已支付',
        2: '已取消',
      }
      const audit_status = {
        0: '待审核',
        1: '审核通过',
        2: '审核未通过',
      }
      const refund_status = {
        0: '未申请',
        1: '退款中',
        2: '已退款',
      }
      return pay_status[this.content.pay_status] || '--'
    },
    changeStatus(e) {
      let query = {
        id: this.content.id,
        status: this.content.status,
      }
      memberOrderUpdate(query).then((res) => {})
    },
    Update(name) {
      let data = {
        id: this.content.id,
      }
      data[name] = this.content[name]
      memberOrderUpdate(data).then((res) => {})
    },

    formatJointProduct(row) {
      if (row.multi_ref_list.length) {
        let str = row.multi_ref_list
          .map((v) => {
            return v.goods_name
          })
          .join(',')
        return str
      } else {
        return '无'
      }
    },
    refund() {
      if (!this.content.refund_amount) {
        this.$message.error(`请填写退款金额`)
        return
      }
      if (!/^(\d+|\d+\.\d{1,2})$/.test(this.content.refund_amount)) {
        this.$message.error(`请填写正确的退款金额`)
        return
      }
      const query = {
        id: this.content.id,
        refund_amount: this.content.refund_amount,
      }
      orderrefund(query)
        .then((res) => {
          this.$message.success(`退款成功`)
          this.content.refund_amount = 0
          this.handleClose()
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    formateActivityStatus(status) {
      const obj = ['正在拼团', '拼团成功', '拼团失败']
      return obj[status]
    },
    formateMulti_ref_listPrice() {
      let arr = this.content.multi_ref_list.map((v) => {
        if (v.price) {
          return v.price.toFixed(2) + '元'
        } else {
          return '未知'
        }
      })
      return arr.join('/')
    },
    formateMulti_ref_listJointPrice() {
      let arr = this.content.multi_ref_list.map((v) => {
        if (v.price) {
          return (v.price - v.joint_price).toFixed(2) + '元'
        } else {
          return '未知'
        }
      })
      return arr.join('/')
    },
    profitSharing() {
      let out_order_no =
        this.content.profit_share_order &&
        this.content.profit_share_order.details
          ? this.content.profit_share_order.details.find((v) => {
              return v.description == '分到个人'
            }).detail_id
          : null
      console.log(out_order_no)
      const data = {
        out_order_no: out_order_no,
        transaction_id: this.content.pay_trade_no,
      }
      profitSharingFinish(data)
        .then((res) => {
          if (res.data.success) {
            this.$message.success(`操作成功`)
            this.fetchOrderdetail()
          }
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
  },
}
</script>

<style lang="less" scoped>
.dialog-wrap {
  .order-wrap {
    display: flex;
    flex-direction: column;
    .wrap-item {
      margin: 20px 40px 0 40px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
  }
  .card-wrap {
    width: 100%;
    padding: 5px;

    .inner {
      min-height: 100px;
      border: 1px dashed #ccc;
      border-radius: 6px;
      padding: 5px 5px 10px;
    }
    .title {
      font-size: 14px;
      font-weight: bold;
    }
    .info-wrap {
      margin-top: 15px;
    }
    .info-row {
      display: flex;
      align-items: center;
      font-size: 13px;

      & + .info-row {
        margin-top: 10px;
      }

      .label {
        width: 120px;
        text-align: right;
        color: #666;
      }
      .goods-name-value {
        margin-left: 10px;
        .goods-name-span {
          display: block;
          margin-bottom: 5px;
        }
      }
      .value {
        flex: 1;
        color: #333;
        margin-left: 10px;
      }
      .properties-style {
        display: inline-block;
        width: 80px;
      }
      img {
        max-width: 80px;
      }
    }
  }

  /deep/ .el-dialog__body {
    padding-top: 10px;
  }
  .result {
    margin-top: 10px;
  }
  .footer {
    margin-top: 10px;
  }
}
</style>
